<template>
  <div class="home">
   <LoaderPage/>
    <Disor/>
    <Loader/>
<Welcome/>
<Home/>
<Explore/>
<About/>
<Projects/>
<Contact/>

  </div>
</template>

<script>
// @ is an alias to /src
import Disor from '@/components/Disor.vue'
import Welcome from '@/components/Welcome.vue';
import Home from '@/components/Home.vue';
import NavBar from '../components/NavBar.vue';
import Explore from '@/components/Explore.vue';
import About from '@/components/About.vue';
import Projects from '@/components/Projects.vue';
import Contact from '@/components/Contact.vue';
import Loader from '@/components/Loader.vue';
import LoaderPage from '@/components/loaderPage.vue';

export default {
  name: 'HomeView',
  components: {
    Disor,
    Welcome,
    Home,
    NavBar,
    Explore,
    About,
    Projects,
    Contact,
    Loader,
    LoaderPage
} ,
mounted(){
  const link = require('../js/disor.js');
  const link2 = require('../js/gsap.js')

  const plugin = document.createElement("script");
    plugin.setAttribute(
      "src",
      link
    );
    plugin.async = true;
    document.head.appendChild(plugin);
    const plugin2 = document.createElement("script");
    plugin.setAttribute(
      "src",
      link2
    );
    plugin.async = true;
    document.head.appendChild(plugin2);
  
 
 }
 
}
</script>
